import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@openng/optimus-ui/button';
import { IconFieldModule } from '@openng/optimus-ui/iconfield';
import { InputIconModule } from '@openng/optimus-ui/inputicon';
import { InputText, InputTextModule } from '@openng/optimus-ui/inputtext';
import { debounceTime, map, startWith } from 'rxjs';

@Component({
  selector: 'core-search-bar',
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    ButtonModule,
  ],
  template: `
    <input
      pInputText
      type="search"
      class="w-full"
      data-testid="search-bar-input"
      [formControl]="filterControl"
      [placeholder]="placeholder()"
      (keydown.escape)="clear()"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent {
  private readonly searchBarInput = viewChild(InputText, { read: ElementRef });

  public readonly placeholder = input('');

  protected readonly filterControl = new FormControl('');
  public readonly searchTermChange = outputFromObservable(
    this.filterControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      map(value => value ?? ''),
    ),
  );

  public focus() {
    this.searchBarInput()?.nativeElement.focus();
  }
  public clear() {
    this.filterControl.setValue('');
  }
}
